import FacebookPixel from './facebook-pixel'
import {
  trackViewContent,
  trackLead,
  trackSearch
} from './facebook-events'

import { actionTypes as propiedadesActionsTypes } from '../../actions/propiedades'
import { actionTypes as contactActionsTypes } from '../../actions/contactForm'

export const facebookPixelEvents = {
  [propiedadesActionsTypes.RECEIVE_DETAIL]: trackViewContent(action => ({
    type: 'viewcontent',
    content_name: action.property.title,
    content_type: 'product',
    content_ids: [action.property.property_code],
    value: (action.property.category_type_id === 9 || !action.property.web_price)
      ? undefined
      : (action.property.operation_type.id === 1
        ? action.property.sale_amount
        : action.property.rental_amount
      ),
    currency: (action.property.category_type_id === 9 || !action.property.web_price)
      ? undefined
      : (action.property.operation_type.id === 1
        ? (action.property.sale_currency.id === 5
          ? 'USD' : 'ARS')
          : (action.property.rental_currency.id === 5 ? 'USD' : 'ARS')
        )
  })),

  [propiedadesActionsTypes.LOAD_PROPERTIES]: trackSearch(action => ({
    type: 'search',
    search_string: action.search
  })),

  [contactActionsTypes.SEND_INFO]: trackLead(action => ({
    type: 'lead',
    content_name: action.info.property_title || action.info.contact_to || undefined,
    content_category: action.info.category || undefined,
    value: action.info.property_value || undefined,
    currency: action.info.property_currency || undefined,
  })),
}

export default FacebookPixel



// WEBPACK FOOTER //
// ./src/tracking/facebook-pixel/index.js